module.exports = __webpack_public_path__ + "img/pantstype_p.08842f0b.png";